/**
 * Socios excluidos del canje (vista previa y ejecución).
 * Añade aquí los _id de MongoDB (24 caracteres hex) que no deban participar.
 */
export const CANJE_EXCLUDED_PARTNER_IDS: string[] = [];

/** Clave estable para dependencias de hooks (orden normalizado). */
export const CANJE_EXCLUDED_PARTNER_IDS_KEY = [...CANJE_EXCLUDED_PARTNER_IDS]
  .map((id) => id.trim())
  .filter(Boolean)
  .sort()
  .join('|');
